import { Classroom } from '@/api/classroom'

const state = () => ({
  listTasks: [],
  listTasksPagination: {},
  detailTask: {},
  loadingTask: false,
  successTask: true,
  messageTask: '',
  savedIdTask: 0,
  savedIdClassroomTask: 0,
})

const getters = {
  listTasks: state => state.listTasks,
  listTasksPagination: state => state.listTasksPagination,
  task: state => state.detailTask,
  loadingTask: state => state.loadingTask,
  successTask: state => state.successTask,
  messageTask: state => state.messageTask,
  savedIdTask: state => state.savedIdTask,
  savedIdClassroomTask: state => state.savedIdClassroomTask,
}

const actions = {
  async fetchAllTasks({commit}, id) {
    commit('setLoadingTask', true)
    commit('setSavedIdClassroomTask', id)
    await Classroom.taskList(id)
      .then(res => {
        commit('setListTasks', res.data.data)
        commit('setListTasksPagination', res.data.pagination)
        commit('setLoadingTask', false)
      })
      .catch(err => {
        console.log(err)
        commit('setLoadingTask', false)
        commit('setMessageTask', err)
      })
  },
  async fetchDetailTask({commit}, id) {
    commit('setLoadingTask', true)
    commit('setSavedIdTask', id)
    await Classroom.taskDetail(id)
      .then(res => {
        commit('setDetailTask', res.data.data)
        commit('setLoadingTask', false)
      })
      .catch(err => {
        console.log(err)
        commit('setLoadingTask', false)
        commit('setMessageTask', err)
      })
  },
  async addTask({commit}, data) {
    const id = data.levelId
    const payload = data.payload
    await Classroom.taskAdd(id, payload)
      .then(res => {
        if(res.data.success) {
          commit('setSuccessTask', true)
          commit('setMessageTask', 'Berhasil Menambahkan Tugas')
        } else {
          commit('setSuccessTask', false)
          commit('setMessageTask', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setMessageTask', err)
        commit('setSuccessTask', false)
      }) 
  },
  async updateTask({commit}, data) {
    const id = data.taskId
    const payload = data.payload
    await Classroom.taskUpdate(id, payload)
      .then(res => {
        if(res.data.success) {
          commit('setSuccessTask', true)
          commit('setMessageTask', 'Berhasil Mengubah Tugas')
        } else {
          commit('setSuccessTask', false)
          commit('setMessageTask', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setSuccessTask', false)
        commit('setMessageTask', err)
      })
  },
  async deleteTask({commit}, id) {
    await Classroom.taskRemove(id)
      .then(res => {
        if(res.data.success) {
          commit('setSuccessTask', true)
          commit('setMessageTask', 'Berhasil Menghapus Tugas')
        } else {
          commit('setSuccessTask', false)
          commit('setMessageTask', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setSuccessTask', false)
        commit('setMessageTask', err)
      })
  }
}

const mutations = {
  setListTasks: (state, tasks) => {
    state.listTasks = tasks
  },
  setListTasksPagination: (state, pagination) => {
    state.listTasksPagination = pagination
  },
  setDetailTask: (state, task) => {
    state.detailTask = task
  },
  setLoadingTask: (state, loading) => {
    state.loadingTask = loading
  },
  setSuccessTask: (state, success) => {
    state.successTask = success
  },
  setMessageTask: (state, message) => {
    state.messageTask = message
  },
  setSavedIdTask: (state, id) => {
    state.savedIdTask = id
  },
  setSavedIdClassroomTask: (state, id) => {
    state.savedIdClassroomTask = id
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}